import request from "superagent";

import { getAuthHeader } from "../utils/superagent";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'name' implicitly has an 'any' type.
export const getFacilityUserAccounts = async ({ name }) => {
  const response = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityUser/accounts`)
    .set(await getAuthHeader())
    .query({ name });
  return response.body.facilities;
};

export const getFacilityUser = async () => {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityUser/findByEmail`)
    .set(await getAuthHeader());
  return body;
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'facilityUserId' implicitly has an 'any' type.
export const refreshContact = async (facilityUserId) => {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .post(`${global.api}/facilityUser/${facilityUserId}/contact-refresh`)
    .set(await getAuthHeader());
};
